import * as React from "react";
import styled from "styled-components";
interface ChequeredStrip {
  location: "bottom" | "top";
}
const ChequeredStrip = styled('div').withConfig({
  shouldForwardProp: (prop) => !['location'].includes(prop)
})<ChequeredStrip>`
  background-image: linear-gradient(45deg, #e6e6e6 25%, transparent 25%),
    linear-gradient(-45deg, #e6e6e6 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #e6e6e6 75%),
    linear-gradient(-45deg, transparent 75%, #e6e6e6 75%);
  background-size: 30px 30px;
  background-position: 0 0, 0 15px, 15px -15px, -15px 0px;
  width: 100%;
  height: 30px;
  position: absolute;
  left: 0;
  ${({ location }) => (location === "top" ? `top: 0px;` : "bottom: 0;")}
`;
const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  height: 30px;
  width: 100%;
`;
const Strip = ({ location }) => (
  <Wrapper>
    <ChequeredStrip location={location} />
  </Wrapper>
);
export default Strip;
